// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat_btn_outline[data-v-15dbb9f7] {
  background: #fff;
  border: 0;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
  font-size: 0.7vw;
  font-weight: 400;
  display: block;
  width: 100%;
  cursor: pointer;
  text-align: center;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiModelsCarousel.vue","webpack://./AiModelsCarousel.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;ACAF","sourcesContent":["\n.chat_btn_outline {\n  background: #fff;\n  border: 0;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n  font-size: 0.7vw;\n  font-weight: 400;\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n}\n",".chat_btn_outline {\n  background: #fff;\n  border: 0;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n  font-size: 0.7vw;\n  font-weight: 400;\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
